import styled from 'styled-components';
import { key } from 'styled-theme';

import { media } from '../../../utils/styles';

export default styled.div`
  display: flex;
  position: relative;
  z-index: 1;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: ${key('sizes.shadowSpace.small')}px;
    background: ${key('colors.white')};
    box-shadow: 0 ${key('sizes.shadowSpace.small')}px 0 0 ${key('colors.white')};
    border-top-left-radius: ${key('sizes.borderRadius')};
    border-top-right-radius: ${key('sizes.borderRadius')};

    ${media.moreThan('md')`
      height: ${key('sizes.shadowSpace.large')}px;
      box-shadow: 0 ${key('sizes.shadowSpace.large')}px 0 0
        ${key('colors.white')};
    `};
  }
`;
